import styles from './filesDropdown.module.scss';
import classnames from 'classnames';
import React from 'react';
import { ReactComponent as CloudUpload } from '../../icons/cloud-upload.svg';

type FilesDropzoneProps = {
  maxAllowedBulkUploadedFiles: number;
};

const FilesDropzone = React.forwardRef<HTMLDivElement, FilesDropzoneProps>(
  ({ maxAllowedBulkUploadedFiles }, ref) => {
    return (
      <div ref={ref} className="dropzone" aria-label="drop files here">
        <div className="dz-message needsclick">
          <CloudUpload />
          <p className={classnames(styles.dzMessage)}>
            Drag and Drop files here, or <span>browse on your computer</span>
          </p>
          <p className={classnames(styles.dzSubtitle)}>
            {`Maximum of ${maxAllowedBulkUploadedFiles} files`}
          </p>
        </div>
      </div>
    );
  }
);

FilesDropzone.displayName = 'FilesDropzone';

export default FilesDropzone;
